import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Component, useState } from 'react';

// ── BETA ACCESS GATE ──
var BETA_CODE = '4705';

function BetaGate({ children }) {
  var [code, setCode] = useState('');
  var [error, setError] = useState(false);

  // Check if already verified this session
  if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('beta_access') === 'granted') {
    return children;
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (code.trim() === BETA_CODE) {
      sessionStorage.setItem('beta_access', 'granted');
      setError(false);
      // Force re-render by updating code
      setCode('');
    } else {
      setError(true);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#FAF7F2', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ maxWidth: '400px', width: '100%', textAlign: 'center' }}>
        <p style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '24px', color: '#2E2019', marginBottom: '8px' }}>
          Do I Have <span style={{ color: '#C4A882' }}>a Story.</span>
        </p>
        <div style={{ width: '40px', height: '1px', background: '#C4A882', margin: '0 auto 24px', opacity: 0.6 }} />
        <p style={{ fontSize: '15px', color: '#7A6555', marginBottom: '24px', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
          This app is currently in private beta testing. Please enter the access code to continue.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            value={code}
            onChange={function (e) { setCode(e.target.value); setError(false); }}
            placeholder="Enter access code"
            autoFocus
            inputMode="numeric"
            maxLength={10}
            style={{
              width: '100%', textAlign: 'center', background: '#FDF9F4',
              border: '2px solid ' + (error ? '#C4665A' : '#E8DFD0'),
              borderRadius: '12px', padding: '16px', fontSize: '24px',
              fontFamily: 'sans-serif', fontWeight: 600, letterSpacing: '0.3em',
              color: '#2E2019', outline: 'none', boxSizing: 'border-box',
              marginBottom: '16px',
            }}
          />
          {error && (
            <p style={{ fontSize: '13px', color: '#C4665A', marginBottom: '12px', fontFamily: 'sans-serif' }}>
              That code isn't right. Please try again.
            </p>
          )}
          <button type="submit" style={{
            width: '100%', background: '#8B6F4E', border: 'none', borderRadius: '100px',
            padding: '16px', fontSize: '16px', fontWeight: 600, color: 'white',
            fontFamily: 'sans-serif', cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(139,111,78,0.35)',
          }}>
            Enter beta
          </button>
        </form>
        <p style={{ fontSize: '11px', color: '#B09A87', marginTop: '24px', fontFamily: 'sans-serif' }}>
          Contact hello@doihaveastory.com if you need an access code.
        </p>
      </div>
    </div>
  );
}

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null, errorInfo: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    this.setState({ errorInfo: info });
    console.error('[ErrorBoundary]', error, info);
    console.error('[ErrorBoundary] Component stack:', info?.componentStack);
  }
  render() {
    if (this.state.error) {
      var msg = this.state.error?.message || '';
      var stack = this.state.errorInfo?.componentStack || '';
      // Extract the failing component name from the stack
      var failingComponent = '';
      if (stack) {
        var match = stack.match(/^\s+at (\w+)/);
        if (match) failingComponent = match[1];
      }
      return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#FAF7F2', padding: '40px 20px', textAlign: 'center' }}>
          <p style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '22px', color: '#2E2019', marginBottom: '16px' }}>Do I Have <em>a Story.</em></p>
          <p style={{ fontSize: '15px', color: '#7A6555', marginBottom: '12px' }}>Something went wrong. Try a hard refresh (Ctrl+Shift+R).</p>
          <button onClick={() => window.location.reload()} style={{ background: '#8B6F4E', border: 'none', borderRadius: '100px', padding: '14px 28px', fontSize: '16px', fontWeight: 600, color: 'white', cursor: 'pointer', marginBottom: '16px' }}>
            Refresh
          </button>
          <button onClick={() => { caches.keys().then(function(names) { names.forEach(function(n) { caches.delete(n); }); }); window.location.reload(); }} style={{ background: 'none', border: '1px solid #E8DFD0', borderRadius: '100px', padding: '10px 24px', fontSize: '13px', color: '#7A6555', cursor: 'pointer', marginBottom: '20px' }}>
            Clear cache &amp; refresh
          </button>
          <div style={{ maxWidth: '500px', textAlign: 'left', background: '#FDF9F4', border: '1px solid #E8DFD0', borderRadius: '12px', padding: '14px 16px', fontSize: '12px', color: '#B09A87', lineHeight: 1.6 }}>
            <p style={{ fontWeight: 600, marginBottom: '4px' }}>Error: {msg}</p>
            {failingComponent && <p>Component: {failingComponent}</p>}
            <p style={{ fontSize: '11px', marginTop: '6px', whiteSpace: 'pre-wrap', maxHeight: '120px', overflow: 'auto' }}>{stack}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
import { AuthProvider, useAuth } from '@/context/AuthContext.jsx';
import { ProjectProvider, useProject } from '@/context/ProjectContext.jsx';
import { FeatureFlagsProvider } from '@/context/FeatureFlagsContext.jsx';
import { NavigationGuardProvider } from '@/context/NavigationGuard.jsx';
import { PageLoader, RequireAuth } from '@/components/layout/index.jsx';
import { UploadRetryIndicator } from '@/components/UploadRetryIndicator.jsx';
import BackToTop from '@/components/BackToTop.jsx';
import { lazy, Suspense } from 'react';

// Retry wrapper for lazy imports — if a chunk fails to load (stale deploy cache),
// retry once with a cache-busting query string before giving up.
function lazyRetry(importFn) {
  return lazy(function () {
    return importFn().catch(function () {
      // First attempt failed — likely stale chunk. Retry with cache bust.
      return new Promise(function (resolve) {
        setTimeout(resolve, 100);
      }).then(function () {
        var url = window.location.href;
        var bust = '_r=' + Date.now();
        // Add cache-bust param so the browser re-fetches index.html
        if (url.indexOf('_r=') === -1) {
          window.location.href = url + (url.indexOf('?') >= 0 ? '&' : '?') + bust;
        }
        // Return a fallback that never resolves — the page will reload
        return new Promise(function () {});
      });
    });
  });
}

const HomePage               = lazyRetry(() => import('./pages/HomePage.jsx'));
const PricingPage            = lazyRetry(() => import('./pages/PricingPage.jsx'));
const PurchasePage           = lazyRetry(() => import('./pages/PurchasePage.jsx'));
const AuthPage               = lazyRetry(() => import('./pages/AuthPage.jsx'));
const OnboardingPage         = lazyRetry(() => import('./pages/OnboardingPage.jsx'));
const StorytellerPage        = lazyRetry(() => import('./pages/StorytellerPage.jsx'));
const FamilyPage             = lazyRetry(() => import('./pages/FamilyPage.jsx'));
const BookPage               = lazyRetry(() => import('./pages/BookPage.jsx'));
const EditorPage             = lazyRetry(() => import('./pages/EditorPage.jsx'));
const StoryStudio            = lazyRetry(() => import('./pages/StoryStudio.jsx'));
const UploadStoriesPage      = lazyRetry(() => import('./pages/UploadStoriesPage.jsx'));
const TranscriptLibraryPage  = lazyRetry(() => import('./pages/TranscriptLibraryPage.jsx'));
const SettingsPage           = lazyRetry(() => import('./pages/SettingsPage.jsx'));
const StorytellerProfilePage = lazyRetry(() => import('./pages/StorytellerProfilePage.jsx'));
const ChaptersPage           = lazyRetry(() => import('./pages/ChaptersPage.jsx'));
const HelpPage               = lazyRetry(() => import('./pages/HelpPage.jsx'));
const TermsPage              = lazyRetry(() => import('./pages/TermsPage.jsx'));
const PrivacyPage            = lazyRetry(() => import('./pages/PrivacyPage.jsx'));
const JoinPage               = lazyRetry(() => import('./pages/JoinPage.jsx'));
const CrewSetupPage          = lazyRetry(() => import('./pages/CrewSetupPage.jsx'));
const BuyStorytellerPage     = lazyRetry(() => import('./pages/BuyStorytellerPage.jsx'));
const AdminPage              = lazyRetry(() => import('./pages/AdminPage.jsx'));
const ProjectPickerPage      = lazyRetry(() => import('./pages/ProjectPickerPage.jsx'));
const PosthumousSettingsPage = lazyRetry(() => import('./pages/PosthumousSettingsPage.jsx'));
const TrusteesPage           = lazyRetry(() => import('./pages/TrusteesPage.jsx'));
const WishesPage             = lazyRetry(() => import('./pages/WishesPage.jsx'));
const LettersPage            = lazyRetry(() => import('./pages/LettersPage.jsx'));
const AdminLegacyPage        = lazyRetry(() => import('./pages/AdminLegacyPage.jsx'));

function LoggedInRedirect() {
  const { user, profile, loading } = useAuth();
  const project = useProject();

  if (loading) return <PageLoader />;
  if (!user) return <HomePage />;
  // Wait for profile + projects to load.
  if (!profile || project.loading) return <PageLoader />;

  // Zero projects → onboarding (or, if the legacy profile.role was set,
  // honor it as a hint to the existing onboarding flow).
  if (project.hasNoProjects) return <Navigate to="/onboarding" replace />;

  // 1 project — go straight in. Destination depends on the project's
  // template: wishes-only users go to the posthumous settings hub,
  // since the memoir-flavored /storyboard doesn't apply to them.
  if (project.activeProject) {
    const ap = project.activeProject;
    if (ap.projectTemplate === 'wishes') {
      return <Navigate to="/legacy/final-wishes" replace />;
    }
    return <Navigate to={ap.role === 'storyteller' ? '/story' : '/storyboard'} replace />;
  }

  // 2+ projects with nothing selected → show the picker.
  return <Navigate to="/projects" replace />;
}

export default function App() {
  return (
    <BetaGate>
    <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <FeatureFlagsProvider>
        <ProjectProvider>
        <NavigationGuardProvider>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Public */}
            <Route path="/"          element={<LoggedInRedirect />} />
            <Route path="/pricing"   element={<PricingPage />} />
            <Route path="/join"         element={<JoinPage />} />
            <Route path="/get-started"  element={<PurchasePage />} />
            <Route path="/crew-setup"   element={<CrewSetupPage />} />
            <Route path="/auth"      element={<AuthPage />} />

            {/* Onboarding — requires auth */}
            <Route path="/onboarding" element={<RequireAuth><OnboardingPage /></RequireAuth>} />
            <Route path="/buy-storyteller" element={<RequireAuth><BuyStorytellerPage /></RequireAuth>} />
            <Route path="/admin"           element={<RequireAuth><AdminPage /></RequireAuth>} />
            <Route path="/projects"        element={<RequireAuth><ProjectPickerPage /></RequireAuth>} />

            {/* App */}
            <Route path="/story"      element={<RequireAuth><StorytellerPage /></RequireAuth>} />
            <Route path="/storyboard" element={<RequireAuth><FamilyPage /></RequireAuth>} />
            <Route path="/family"     element={<Navigate to="/storyboard" replace />} />
            <Route path="/chapters"   element={<RequireAuth><ChaptersPage /></RequireAuth>} />
            <Route path="/book/:storytellerId?"   element={<RequireAuth><BookPage /></RequireAuth>} />
            <Route path="/story-studio/:storytellerId?" element={<RequireAuth><StoryStudio /></RequireAuth>} />
            <Route path="/upload-stories" element={<RequireAuth><UploadStoriesPage /></RequireAuth>} />
            <Route path="/transcripts"    element={<RequireAuth><TranscriptLibraryPage /></RequireAuth>} />
            <Route path="/editor/:storytellerId?" element={<Navigate to="/story-studio" replace />} />
            <Route path="/settings"              element={<RequireAuth><SettingsPage /></RequireAuth>} />

            {/* Legacy & Wishes (per LEGACY-AND-WISHES-DESIGN.md) */}
            <Route path="/legacy/final-wishes" element={<RequireAuth><PosthumousSettingsPage /></RequireAuth>} />
            {/* Old URL kept as alias so any bookmarks or in-flight links survive. */}
            <Route path="/legacy/posthumous" element={<Navigate to="/legacy/final-wishes" replace />} />
            <Route path="/legacy/trustees"   element={<RequireAuth><TrusteesPage /></RequireAuth>} />
            <Route path="/legacy/wishes"     element={<RequireAuth><WishesPage /></RequireAuth>} />
            <Route path="/legacy/letters"    element={<RequireAuth><LettersPage /></RequireAuth>} />
            <Route path="/admin/legacy"      element={<RequireAuth><AdminLegacyPage /></RequireAuth>} />
            <Route path="/storyteller-profile"   element={<RequireAuth><StorytellerProfilePage /></RequireAuth>} />
            <Route path="/help"                  element={<HelpPage />} />
            <Route path="/plans"                 element={<Navigate to="/settings" replace />} />
            <Route path="/terms"                 element={<TermsPage />} />
            <Route path="/privacy"               element={<PrivacyPage />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <UploadRetryIndicator />
        <BackToTop />
        </NavigationGuardProvider>
        </ProjectProvider>
        </FeatureFlagsProvider>
      </AuthProvider>
    </BrowserRouter>
    </ErrorBoundary>
    </BetaGate>
  );
}
